/**
 * Auth Mapper
 * Maps between API DTOs and Domain Entities
 */

import { LoginResponseDTO } from "../models/AuthDTOs";
import { AuthResultEntity } from "../../domain/entities/AuthResult";

export class AuthMapper {
  /**
   * Convert LoginResponseDTO to AuthResultEntity
   */
  static toAuthResult(dto: LoginResponseDTO): AuthResultEntity {
    if (!dto.success || !dto.data) {
      throw new Error(dto.message || "Login failed");
    }

    // Handle both string "1" and number 1 for boolean fields
    const isActive =
      dto.data.user.is_active === 1 || dto.data.user.is_active === "1";
    const isMasterAdmin =
      dto.data.user.is_master_admin === 1 ||
      dto.data.user.is_master_admin === "1";

    return {
      token: dto.data.token,
      user: {
        id:
          typeof dto.data.user.id === "string"
            ? parseInt(dto.data.user.id)
            : dto.data.user.id,
        email: dto.data.user.email,
        userName: dto.data.user.userName,
        is_active: isActive,
        is_master_admin: isMasterAdmin,
        password_changed_at: dto.data.user.password_changed_at,
        created_at: dto.data.user.created_at,
        updated_at: dto.data.user.updated_at,
      },
    };
  }
}
